<section id="searchParameters">
    <form #f="ngForm" (submit)="onSubmit(f.value)">
        <h2 tabindex="0" role="form">Search Parameters</h2>
        <div class="row">
            <div class="col-xl-4">
              <fieldset role="radiogroup" id="gender"> 
                <legend>Gender</legend> 
                <input role="radio" tabindex="0" type="radio" id="male" name="gender" value="male" [(ngModel)]="gender">
                <label tabindex="0" for="male">Male</label>
                <input role="radio" tabindex="0" type="radio" id="female" name="gender" value="female" [(ngModel)]="gender">
                <label tabindex="0" for="female">Female</label>
              </fieldset>
            </div>
            <div class="col-xl-4">
                <label for="brands" tabindex="0">Brand:</label>
                <select role="listbox" name="brands" id="brands" tabindex="0" [(ngModel)]="brand">
                    <option role="listitem" value="New Balance">New Balance</option>
                    <option role="listitem" value="Saucony">Saucony</option>
                    <option role="listitem" value="Nike">Nike</option>
                    <option role="listitem" value="Asics">Asics</option>
                </select>
            </div>
            <div class="col-xl-4">
                <label for="searchTerm" tabindex="0">Key Words:</label>
                <input role="textbox" id="searchTerm" name="searchTerm" tabindex="0" [(ngModel)]="searchTerm">
            </div>
        </div>
        <button role="button" type="submit" value="Submit" id="Search">Submit</button>
        <button type="button" id="clear" (click)="clearResults()">Clear Results</button>
    </form>
    <ngx-spinner size="large" type="ball-spin-clockwise" role="status">
      <span class="sr-only">Loading...</span>
    </ngx-spinner>
    <h2 class="alert" *ngIf="this.resultsAreEmpty">No Results Found</h2>
</section>
<app-search-results [results]="results">
</app-search-results>
<app-favorites-list [favorites]="favorites"></app-favorites-list>